import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-header-button',
  templateUrl: './header-button.component.html',
})
export class HeaderButtonComponent{
  @Input() label = '';
  @Input() svg = '';
  @Input() link = false;
  @Input() icon = '';
  @Input() loading = false;
  @Input() disabled = false;
  @Input() selected: boolean = false;
  isHovered: boolean = false;

  @Output() sendClick = new EventEmitter();

  onClick(event: MouseEvent) {
    this.sendClick.emit(event);
  }
}
